"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));

var _isEqual = _interopRequireDefault(require("lodash/fp/isEqual"));

var _compact = _interopRequireDefault(require("lodash/fp/compact"));

var _AutoSuggest = _interopRequireDefault(require("../autosuggest/AutoSuggest"));

var _CustomSuggestionItem = _interopRequireDefault(require("./CustomSuggestionItem"));

var _TagManagerItemList = _interopRequireDefault(require("./TagManagerItemList"));

var _excluded = ["tagList", "tagSuggestions", "placeholder", "className", "customTagPlaceholder", "dropdownSeparatorText", "onTagListChange", "useCustomTags", "noItemMessage", "showInput"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getCustomSuggestion = function getCustomSuggestion(value, placeholder) {
  return {
    customSuggestion: /*#__PURE__*/_react.default.createElement(_CustomSuggestionItem.default, {
      value: value,
      placeholder: placeholder
    }),
    label: value,
    disabled: (0, _isEmpty.default)(value)
  };
};

var getSuggestionSeparator = function getSuggestionSeparator(dropdownSeparatorText) {
  return {
    header: true,
    label: dropdownSeparatorText
  };
};

var cleanupTagState = function cleanupTagState(tag) {
  delete tag.toAdd;
  delete tag.toRemove;
  return tag;
};

var hasTagAlreadySelected = function hasTagAlreadySelected(tags, newSuggestion) {
  return !!tags.find(function (tag) {
    return tag.label === newSuggestion.label;
  });
};

var getNewSuggestion = function getNewSuggestion(suggestion) {
  var newSuggestion = suggestion.customSuggestion ? {
    label: suggestion.label
  } : suggestion;
  newSuggestion.toAdd = true;
  return newSuggestion;
};

var buildSuggestions = function buildSuggestions(useCustomTags, customTagPlaceholder, dropdownSeparatorText) {
  return function (value, suggestions) {
    var cleanedSuggestions = suggestions.map(cleanupTagState);
    return (0, _compact.default)([useCustomTags && getCustomSuggestion(value, customTagPlaceholder), useCustomTags && !(0, _isEmpty.default)(cleanedSuggestions) && getSuggestionSeparator(dropdownSeparatorText)].concat((0, _toConsumableArray2.default)(cleanedSuggestions)));
  };
};

var filterSuggestions = function filterSuggestions(suggestions, selectedTagNames) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return suggestions.filter(function (suggestion) {
    var label = suggestion.label;

    if (!label) {
      return false;
    }

    var lowerCaseLabel = label.toLowerCase();
    var lowerCaseValue = value.toLowerCase();
    return lowerCaseLabel.includes(lowerCaseValue) && !selectedTagNames.includes(label) && !suggestion.header && !suggestion.customSuggestion;
  });
};

var TagManager = function TagManager(props) {
  var tagList = props.tagList,
      tagSuggestions = props.tagSuggestions,
      placeholder = props.placeholder,
      className = props.className,
      customTagPlaceholder = props.customTagPlaceholder,
      dropdownSeparatorText = props.dropdownSeparatorText,
      onTagListChange = props.onTagListChange,
      useCustomTags = props.useCustomTags,
      noItemMessage = props.noItemMessage,
      showInput = props.showInput,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);

  var _useState = (0, _react.useState)(tagList),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tags = _useState2[0],
      setTags = _useState2[1];

  var _useState3 = (0, _react.useState)(''),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      inputValue = _useState4[0],
      setInputValue = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      currentSuggestions = _useState6[0],
      setCurrentSuggestions = _useState6[1];

  var getSuggestions = buildSuggestions(useCustomTags, customTagPlaceholder, dropdownSeparatorText); // Update internal list of tags when they change from the outside i.e. when they have been saved,
  // additionally, cleanup previous state for adding or removing tags

  (0, _react.useEffect)(function () {
    return setTags(tagList.map(cleanupTagState));
  }, [tagList]); // build suggestion when passed tag suggestions passed change i.e. when a tag got selected and removed from the list

  (0, _react.useEffect)(function () {
    return setCurrentSuggestions(getSuggestions(inputValue, tagSuggestions));
  }, [tagSuggestions]); // build suggestions when input value change as it should filter the list on suggestions

  (0, _react.useEffect)(function () {
    var selectedTagNames = tags.map(function (tag) {
      return tag.label;
    });
    var value = inputValue || '';
    var filteredList = filterSuggestions(tagSuggestions, selectedTagNames, value);
    setCurrentSuggestions(getSuggestions(value, filteredList));
  }, [tags, inputValue, tagSuggestions]);

  var updateTags = function updateTags(updatedTags) {
    setTags(updatedTags); // Notify outside component

    onTagListChange(updatedTags);
  };

  var handleSuggestionsChange = function handleSuggestionsChange(_ref) {
    var value = _ref.value;
    return setInputValue(value);
  };

  var handleSuggestionSelected = function handleSuggestionSelected(event, _ref2) {
    var suggestion = _ref2.suggestion;
    setInputValue('');
    var newSuggestion = getNewSuggestion(suggestion);

    if (hasTagAlreadySelected(tags, newSuggestion)) {
      updateTags((0, _toConsumableArray2.default)(tags));
      return;
    }

    updateTags([].concat((0, _toConsumableArray2.default)(tags), [newSuggestion]));
  };

  var updateTagsWithSelectedTag = function updateTagsWithSelectedTag(tagItems, selectedTag) {
    var updatedTags = tagItems.map(function (tag) {
      if ((0, _isEqual.default)(tag.label, selectedTag.label)) {
        // update tag and mark as "to remove"
        if (tag.toRemove) {
          delete tag.toRemove;
        } else {
          tag.toRemove = true;
        }
      }

      return tag;
    });
    return updatedTags;
  };

  var handleRemoveFromTagList = function handleRemoveFromTagList(selectedTag) {
    if (selectedTag.toAdd) {
      updateTags(tags.filter(function (tag) {
        return !(0, _isEqual.default)(tag, selectedTag);
      }));
    } else {
      updateTags(updateTagsWithSelectedTag(tags, selectedTag));
    }
  };

  var inputProps = {
    className: '',
    placeholder: placeholder || 'Start typing ...',
    value: inputValue,
    tabIndex: 1
  };
  var autosuggestClasses = (0, _classnames.default)(!(0, _isEmpty.default)(tags) && 'margin-bottom-10');
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, remainingProps, {
    className: (0, _classnames.default)('TagManager', className)
  }), showInput && /*#__PURE__*/_react.default.createElement(_AutoSuggest.default, {
    className: autosuggestClasses,
    inputProps: inputProps,
    suggestions: currentSuggestions,
    onSuggestionSelected: handleSuggestionSelected,
    onSuggestionsFetchRequested: handleSuggestionsChange,
    openOnFocus: true,
    noItemMessage: noItemMessage
  }), /*#__PURE__*/_react.default.createElement(_TagManagerItemList.default, {
    tags: tags,
    onRemoveFromTagList: handleRemoveFromTagList
  }));
};

TagManager.defaultProps = {
  useCustomTags: true,
  showInput: true
};
TagManager.propTypes = {
  tagList: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string
  })).isRequired,
  tagSuggestions: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string
  })).isRequired,
  onTagListChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  customTagPlaceholder: _propTypes.default.string,
  dropdownSeparatorText: _propTypes.default.string,
  useCustomTags: _propTypes.default.bool,
  noItemMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  showInput: _propTypes.default.bool,
  className: _propTypes.default.string
};
var _default = TagManager;
exports.default = _default;